export default {
  'diagnostics.list.header.customer': 'Customer',
  'diagnostics.list.header.creation': 'Creation Date',
  'diagnostics.list.header.entryDate': 'Entry Date',
  'diagnostics.list.header.plate': 'Plate',
  'diagnostics.list.newDiagnostics': 'New diagnostics',
  'diagnostics.form.company': 'Company',
  'diagnostics.form.vehicle.title': 'Customer Vehicle',
  'diagnostics.form.vehicle.description':
    'Click search to search for a customer',
  'diagnostics.form.obs': 'Customer report',
  'diagnostics.form.partsList': 'Parts List',
  'diagnostics.form.partsList.status.ok': 'Ok',
  'diagnostics.form.partsList.status.replace': 'To replace',
  'diagnostics.form.partsList.status.repair': 'Repair',
  'diagnostics.form.partsList.header.description': 'Description',
  'diagnostics.form.partsList.header.status': 'Status',

  'diagnostics.form.notification.success.title':
    'Diagnostic created successfully!',
  'diagnostics.form.notification.success.description':
    'The diagnostic was successfully saved to the system.',

  'diagnostics.form.notification.error.title':
    'There was an error saving the diagnosis!',
  'diagnostics.form.notification.error.description':
    'Check the fields and try again',

  'diagnostics.remove.notification.success.title':
    'Diagnosis deleted successfully',
  'diagnostics.remove.notification.success.description':
    'The diagnostic was successfully deleted.',

  'diagnostics.remove.notification.error.title': 'Error deleting diagnosis!',
  'diagnostics.remove.notification.error.description':
    'An error occurred deleting the diagnostic.',

  'diagnostics.update.notification.success.title':
    'Diagnosis updated successfully',
  'diagnostics.update.notification.success.description':
    'The diagnostic has been successfully updated.',

  'diagnostics.update.notification.error.title': 'Error updating diagnostics!',
  'diagnostics.update.notification.error.description':
    'An error occurred while updating the diagnostics.',

  'diagnostics.modal.title': 'Search Vehicle',
  'diagnostics.modal.button.select': 'Select',
  'diagnostics.modal.steps.selectCustomer': 'Select Customer',
  'diagnostics.modal.steps.selectVehicle': 'Select Vehicle',
  'diagnostics.modal.vehicles.licensePlate': 'Plate',
  'diagnostics.modal.vehicles.description': 'Details',
  'diagnostics.modal.remove.title': 'Remove diagnostic',
  'diagnostics.modal.remove.content':
    'Do you really want to remove this diagnostic?',

  'diagnostics.form.vehicle': 'Vehicle',
  'diagnostics.form.vehicle.customer': 'Customer',
  'diagnostics.form.vehicle.plate': 'Plate',

  'diagnostics.modal.report.title': 'Diagnostic report',
  'diagnostics.modal.report.error.title': 'Error generating report',
  'diagnostics.modal.report.error.description':
    'An error occurred while generating the report.',

  'diagnostics.modal.generateBudget.title': 'Generate Budget',
  'diagnostics.modal.generateBudget.btn.generateBudget': 'Generate Budget',
  'diagnostics.modal.generateBudget.btn.close': 'Close',
  'diagnostics.modal.generateBudget.checkbox.demand': 'Charge Diagnosis?',
  'diagnostics.modal.generateBudget.checkbox.include':
    'Include part in the Budget',
};
